<label
  class="fld"
  appSisFieldLoading
  [loading]="effectiveLoading"
  [loadedKey]="loadedKey"
  [loadedMessage]="loadedMessage"
  [loadFailed]="loadFailed"
  [class.err]="!!error"
  [attr.data-disabled]="isLockedOrDisabled || null">
  <span class="lab">{{ label }}</span>
  <span class="inp" [class.has-alert]="loadFailed">
    <select
      [id]="selectId"
      [value]="value"
      [disabled]="isLockedOrDisabled"
      [attr.aria-invalid]="error ? 'true' : null"
      [attr.aria-describedby]="describedBy"
      (mousedown)="onTogglePicker()"
      (keydown)="onKeydown($event)"
      (change)="onSelect($event)"
      (blur)="onBlur()">
      <option value="" [disabled]="!!placeholder">{{ placeholder }}</option>
      <option
        *ngFor="let option of options"
        [value]="option.value"
        [disabled]="option.disabled"
        [selected]="option.value === value">
        {{ option.label }}
      </option>
    </select>
    <!-- Los iconos flotan sobre el select (que ocupa todo el ancho de .inp) para
         que un click en la flecha abra el desplegable nativo sin JavaScript. -->
    <span class="ico-group" aria-hidden="true">
      <span *ngIf="loadFailed" class="ico ico-alert">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13A6.5 6.5 0 0 0 8 1.5ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4.5Zm0 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/>
        </svg>
      </span>
      <span class="ico ico-chevron" [class.open]="pickerOpen"></span>
    </span>
  </span>
  <ng-container *ngIf="loadFailed; else normalHelper">
    <span class="help load-failed" [id]="error ? selectId + '-error' : selectId + '-helper'">
      {{ helperText }}
      <ng-container *ngIf="showRetry">
        &nbsp;
        <button
          type="button"
          class="btn-retry"
          [attr.aria-label]="'Reintentar carga de ' + label"
          (click)="retryLoad.emit(); $event.preventDefault()">
          Reintentar
        </button>
      </ng-container>
    </span>
  </ng-container>
  <ng-template #normalHelper>
    <span *ngIf="helperText" class="help" [id]="error ? selectId + '-error' : selectId + '-helper'">{{ helperText }}</span>
  </ng-template>
</label>
